// src/Component/hooks/usePostPengeluaran.jsx
import { useState } from 'react';
import api from '../Services/api';
import endpoints from '../Services/endpointAdmin';

/**
 * @returns { Object } - Mengembalikan fungsi postPengeluaran, serta status loading dan error.
 */
const usePostPengeluaran = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  /**
   * Fungsi untuk mengirim data pengeluaran ke backend.
   * @param { number } id_user
   * @param { number } id_detail_pengeluaran
   * @param { number } id_detail_himpun
   * @param { number } id_himpun
   * @param { string } sumber_dana
   * @param { string } user_input
   * @param { string } lembaga
   * @param { string } tanggal
   * @param { string } departemen
   * @returns { Promise<Object> } - Mengembalikan data respons dari backend atau error.
   */
  const postPengeluaran = async (
    id_user,
    id_detail_pengeluaran,
    id_detail_himpun,
    id_himpun,
    sumber_dana,
    user_input,
    lembaga,
    tanggal,
    departemen
  ) => {
    setLoading(true);
    setError(null);

    try {
      const data = {
        id_user,
        id_detail_pengeluaran,
        id_detail_himpun,
        id_himpun,
        sumber_dana,
        user_input,
        lembaga,
        tanggal,
        departemen,
      };

      const response = await api.post(endpoints.pengeluaran.create, data, {
        headers: {
          'Content-Type': 'application/json',
        },
      });

      return response.data;
    } catch (err) {
      console.error('Error uploading pengeluaran:', err);
      setError(
        err.response?.data?.error ||
        err.response?.data?.message ||
        'Terjadi kesalahan saat mengupload data pengeluaran.'
      );
      return null;
    } finally {
      setLoading(false);
    }
  };

  return { postPengeluaran, loading, error };
};

export default usePostPengeluaran;
